import { z } from "zod";
import { CITIES, INTERESTS, LANGUAGES } from "../types/domain.js";

export const fullNameSchema = z
  .string()
  .trim()
  .min(2, "Имя слишком короткое")
  .max(40, "Имя слишком длинное");

export const ageSchema = z
  .number()
  .int()
  .min(16, "Минимальный возраст — 16")
  .max(99, "Слишком большой возраст");

export const citySchema = z.enum(CITIES);
export const interestsSchema = z.array(z.enum(INTERESTS)).min(1, "Выбери хотя бы один интерес");
export const languagesSchema = z.array(z.enum(LANGUAGES)).min(1, "Выбери хотя бы один язык");

export const profileSchema = z.object({
  full_name: fullNameSchema,
  age: ageSchema,
  city: citySchema,
  interests: interestsSchema,
  languages: languagesSchema,
});

export type ProfileInput = z.infer<typeof profileSchema>;
